import React from 'react';
import styleClasses from '../../containers/menu/menu.module.scss';

interface SearchBarProps {
    targetState?: any,
    setTargetState?: any,
    searchHandle?: () => void,
    clearSearch?: () => void,
    searchtrack?:any,
}
const ItemSearch:React.FC<SearchBarProps> = ({targetState,setTargetState,searchHandle,clearSearch, searchtrack}) => {
  return (
    <div className={`${styleClasses.search_bar_wrap} ${searchtrack} search-bar-wrap`}>
          <div
            className={`${styleClasses.search_inn_content} d-flex align-items-center px-md-5 px-4`}
          >
            <span className={styleClasses.search_bar_icon}>
              <img
                src={require("../../images/search-icon.svg")}
                className="img-fluid"
                alt="search icon"
              />
            </span>
            <input
              type="search"
              className={`${styleClasses.form_control} form-control`}
              onChange={(e) => setTargetState(e.target.value)}
              onKeyPress={(e) => e.key === "Enter" && searchHandle()}
              value={targetState}
              autoFocus
            />
            <button
              type="button"
              className={`${styleClasses.search_result_btn} btn btn-large text-uppercase f-s16 mw-auto mx-content py-1 px-3 me-3 d-none d-md-block`}
              onClick={searchHandle}
            >
              Search
            </button>
            <button
              type="button"
              className={`${styleClasses.search_close_btn} btn btn-custom modal-close-button position-static p-0`}
              onClick={() => {
                searchHandle();
                clearSearch();
              }}
            >
              Close
            </button>
          </div>
        </div>
  )
}

export default ItemSearch;